import Navbar from 'components/navbar';
import { Outlet } from 'react-router-dom';

const SalesPlanUpdatedHoc = () => {
  return (
    <div>
      <Navbar heading="FDP Updated - Sales Plan (15-Month)" searchComponent={<></>} progressComponent={<></>} />
      <Outlet />
    </div>
  );
};

export default SalesPlanUpdatedHoc;
